import { INDEX_HEADER_BLACK_LIST, SYSTEM_BLACK_LIST } from "@/libs/constants";

export const showIndexHeader = (pathname: string) => {
  if (
    INDEX_HEADER_BLACK_LIST.includes(pathname) ||
    SYSTEM_BLACK_LIST.includes(pathname)
  ) {
    return false;
  } else if (
    INDEX_HEADER_BLACK_LIST.some((prefix) => pathname.startsWith(prefix))
  ) {
    // 移动端通过一级路由判断是否展示头部
    return false;
  }

  return true;
};
